import { ExpenseCategoryType, ExpenseClaimState, ExpenseSubCategory } from './../../../../core/models/expense.model';
import { Component, Input, OnInit } from '@angular/core';
import { StringHelper } from 'app/core/helpers/string-helper';
import { ExpenseClaimViewModel } from 'app/core/models/expense.model';

@Component({
  selector: 'app-expense-cost',
  templateUrl: './expense-cost.component.html',
  styleUrls: ['./expense-cost.component.scss']
})
export class ExpenseCostComponent implements OnInit {
  @Input() expense: ExpenseClaimViewModel;
  @Input() selectedTab: ExpenseClaimState;
  @Input() dataLoaded: boolean;

  ExpenseCategoryType = ExpenseCategoryType;
  ExpenseSubCategory = ExpenseSubCategory;
  stringHelper = StringHelper;

  constructor() { }

  ngOnInit(): void {
  }

  isCaxtonTab() {
    return this.selectedTab === ExpenseClaimState.AutomatedPaymentApproved || this.selectedTab === ExpenseClaimState.Processing || this.selectedTab === ExpenseClaimState.AutomatedPaymentFailed;
  }

  get hasAiReceiptData(): boolean {
    return this.expense.receipts?.length > 0 && this.expense.receipts.some(r => r.amount != null);
  }

  get receiptTotal(): number {
    if (!this.hasAiReceiptData) return 0;
    return this.expense.receipts
      .filter(r => r.amount != null)
      .reduce((sum, r) => sum + r.amount, 0);
  }

  get receiptCurrencyMatches(): boolean {
    if (!this.hasAiReceiptData) return false;
    const processedReceipts = this.expense.receipts.filter(r => r.amount != null);
    if (processedReceipts.some(r => !r.currency)) return false;
    return processedReceipts.every(r => r.currency === this.expense.currency);
  }

  get receiptAmountMatches(): boolean {
    return this.hasAiReceiptData &&
      Math.round(this.receiptTotal * 100) === Math.round(this.expense.amount * 100) &&
      this.receiptCurrencyMatches;
  }

  get receiptCategoryMatches(): boolean {
    if (!this.hasAiReceiptData) return false;
    return this.expense.receipts
      .filter(r => r.amount != null && r.categoryName)
      .every(r => r.categoryName === this.expense.categoryName);
  }

  get categoryMismatchReason(): string {
    if (!this.expense.receipts) return '';
    const categories = [...new Set(
      this.expense.receipts
        .filter(r => r.amount != null && r.categoryName)
        .map(r => r.categoryName)
    )];
    return `AI categorised receipt as "${categories.join(', ')}" but claim category is "${this.expense.categoryName}"`;
  }

  get receiptMismatchReason(): string {
    if (!this.expense.receipts) return '';
    const reasons: string[] = [];
    const processedReceipts = this.expense.receipts.filter(r => r.amount != null);

    if (!this.receiptCurrencyMatches) {
      const currencies = [...new Set(processedReceipts.filter(r => r.currency).map(r => r.currency))];
      reasons.push(`Receipt currency (${currencies.join(', ')}) does not match claim currency (${this.expense.currency})`);
    }

    const total = this.receiptTotal;
    if (Math.round(total * 100) !== Math.round(this.expense.amount * 100)) {
      reasons.push(`Receipt total (${total.toFixed(2)}) does not match claim amount (${this.expense.amount.toFixed(2)})`);
    }

    return reasons.join('. ');
  }
}
